import React from "react";

import { ApolloProvider, Query } from "react-apollo";
import client from "lib/ApolloClient";
import ReactLoading from "react-loading";
import DataList from "components/list/DataList";
import DBDisplayComp from "components/resource/DBDisplayComp";
import GraphqlFragment from "lib/GraphqlFragment";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import { navigate } from "gatsby";
import DBResourceQueryGroupComp from "components/resource/DBResourceQueryGroupComp";
import DBResourceDetailLightBox from "components/resource/DBResourceDetailLightBox";
import ResourceCharactersMapping from "components/resource/ResourceCharactersMapping";
import ResourceSubjectMapping from "components/resource/ResourceSubjectMapping";
import ResourceUnitMapping from "components/resource/ResourceUnitMapping";
import ResourceClassMapping from "components/resource/ResourceClassMapping";
import cateAPI from "lib/cateAPI";
import { inject, observer } from "mobx-react";
import ReactHtmlParser from "react-html-parser";

const getDBResourceList = gql`
  query getDBResourceList($searchForm: SearchForm) {
    getDBResourceList(Input: $searchForm) {
      display {
        field
        name
        position
        type
      }
      sort {
        name
        order
        field
        default
      }
      batch {
        ...getElemtn
      }
      list {
        values {
          ref {
            key
            value
          }
          resourceItem {
            recommendResource
            newResource
            trialResource
            joCount
            pJoCount
            ebookCount
            dbAttachList {
              showName
              attachPath
            }
            dbURLList {
              showName
              url
              openWin
            }
          }
        }
      }
      options {
        max
        pagesize
        showpage
      }
      info {
        total
        count
        limit
        pageNo
        totalPage
        start
        hyftdToken
        userCollectionList
        sortFieldList {
          type
          message
        }
        journalCollect
        ermEJournal
        ermProcLink
        pages {
          val
          active
        }
        showNext
        showPrevious
      }
    }
  }
  ${GraphqlFragment.defaultLayoutFragment}
`;

const getResourceBrowseMapping = gql`
  query getResourceBrowseMapping($searchForm: SearchForm) {
    getResourceBrowseMapping(Input: $searchForm) {
      showSubjectClass
      unitSwitch
      unitSwitchMessage
      classSN
      browseOrder
    }
  }
`;

@inject("appStore")
@observer
class DBResourceListComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: props.readerStore.auth,
      dbID: "",
      resourceType: "databases",
      isAllTag: false,
      ids: [],
      sortFieldList: [],
      showSort: false,
      showFilter: false,
      refetch: null,
    };
  }

  componentWillReceiveProps(props) {
    if (
      JSON.stringify(props.searchForm) !== JSON.stringify(this.props.searchForm)
    ) {
      this.setState({ ids: [] });
    }
    if (this.state.auth !== props.readerStore.auth) {
      this.setState({ auth: props.readerStore.auth });
    }
  }

  @autobind
  handleShowSort(e) {
    e.preventDefault();
    this.setState({ showSort: !this.state.showSort });
  }

  @autobind
  changeShowType(showType, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.showType = showType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  onQueryCompleted(data) {
    let { info, list } = data.getDBResourceList;
    let {
      limit,
      start,
      count,
      userCollectionList,
      sortFieldList,
      total,
    } = info;
    let { search, location } = this.props;
    let params = { ...search };
    let { resourceConfig } = this.props.appStore;
    let { values } = list;
    let size = limit;
    if (count - start < size) {
      size = count - start;
    }
    /*let tagSize = 0;
    let ids = [];

    values.map((value) => {
      let { ref } = value;
      ref.map((v) => {
        if (v.key === "id") {
          ids.push(v.value);
          if (userCollectionList !== null) {
            if (userCollectionList.includes(v.value)) {
              tagSize++;
            }
          }
        }
      });
    });

    let isAllTag = this.state.isAllTag;
    if (size === tagSize) {
      isAllTag = true;
    } else {
      isAllTag = false;
    }
    let idsEqual =
      ids.length === this.state.ids.length &&
      ids.every((id, k) => id === this.state.ids[k]);
    if (isAllTag !== this.state.isAllTag || !idsEqual) {
      this.setState({ isAllTag: isAllTag, ids: ids });
    }*/

    if (
      sortFieldList !== null &&
      JSON.stringify(sortFieldList) !== JSON.stringify(this.state.sortFieldList)
    ) {
      this.setState({ sortFieldList: sortFieldList });
    }

    if (total !== this.props.appStore.dbResourceCount) {
      this.props.appStore.setDBResourceCount(total);
    }

    if (total === 0 && params.searchTarget !== params.resourceType) {
      if (resourceConfig && resourceConfig.resourceTabList) {
        let breakPoint = false;
        resourceConfig.resourceTabList.map((resourceTab) => {
          if (breakPoint) {
            return "";
          }
          if (
            resourceTab === "journal" &&
            this.props.appStore.journalResourceCount > 0
          ) {
            this.setResourceType("journal");
            breakPoint = true;
          } else if (
            resourceTab === "paper_journal" &&
            this.props.appStore.pJournalResourceCount > 0
          ) {
            this.setResourceType("paper_journal");
            breakPoint = true;
          } else if (
            resourceTab === "ebook" &&
            this.props.appStore.ebookResourceCount > 0
          ) {
            this.setResourceType("ebook");
            breakPoint = true;
          }
        });
      }
    }
  }

  @autobind
  setResourceType(resourceType) {
    let { search, location } = this.props;
    let params = { ...search };
    params.resourceType = resourceType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  handleTagAll(e) {
    e.preventDefault();
    if (this.state.auth) {
      if (!this.state.isAllTag) {
        cateAPI
          .addListCate(this.state.ids, this.props.resourceType)
          .then((data) => {
            if (this.state.refetch !== null) {
              this.state.refetch();
            }
          });
      } else {
        cateAPI
          .delListCate(this.state.ids, this.props.resourceType)
          .then((data) => {
            if (this.state.refetch !== null) {
              this.state.refetch();
            }
          });
      }
    } else {
      this.props.appStore.openLogin();
    }
  }

  @autobind
  getRefetch(refetch) {
    this.setState({ refetch: refetch });
  }

  @autobind
  changeSortType(sortType, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.sort = sortType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
    this.setState({ showSort: false });
  }

  @autobind
  changeShowFilter(type) {
    if (type) {
      this.setState({ showFilter: true });
      document.body.classList.add("fix");
    } else {
      this.setState({ showFilter: false });
      document.body.classList.remove("fix");
    }
  }

  @autobind
  handleClick(item) {
    this.setState({ dbID: item.id });
    this.detailLightBox.popup();
    window.history.pushState(
      "",
      "",
      "/resourceDetail?resourceType=databases&id=" + item.id
    );
  }

  @autobind
  changePageType(pageType, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {};
    params.resourceType = search.resourceType;
    params.pageType = pageType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  changePageTypeWithClassSN(sn, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.resourceType = search.resourceType;
    params.pageType = "class";
    params.par = sn;
    params.sc = "1";
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  render() {
    let { searchForm, appStore, t, pageType } = this.props;
    let {
      isAllTag,
      showSort,
      sortFieldList,
      filterTop,
      dbID,
      resourceType,
      showFilter,
    } = this.state;
    let { dbResourceCount } = appStore;
    let toTagAll = true;
    if (isAllTag && dbResourceCount > 0) {
      toTagAll = false;
    }
    let showList = false;
    if (pageType === "list" || pageType === "search" || pageType === "hot") {
      showList = true;
    } else if (pageType === "subject" && searchForm.subject !== undefined) {
      showList = true;
    } else if (
      pageType === "unit" &&
      (searchForm.college !== undefined || searchForm.unit !== undefined)
    ) {
      showList = true;
    } else if (
      pageType === "class" &&
      searchForm.par !== undefined &&
      searchForm.sc !== "1"
    ) {
      showList = true;
    }
    return (
      <>
        {showList && (
          <DBResourceQueryGroupComp
            {...this.props}
            changeShowFilter={this.changeShowFilter}
            sortFieldList={this.state.sortFieldList}
            showList={showList}
            showFilter={showFilter}
          />
        )}
        <div className="search_result">
          <h2>{t("jumperrwd.common.searchResult")}</h2>
          {pageType !== "search" && (
            <ApolloProvider client={client.jumperrwdClient}>
              <Query
                query={getResourceBrowseMapping}
                variables={{
                  searchForm: this.props.searchForm,
                }}
                fetchPolicy="network-only">
                {({ loading, error, data, refetch }) => {
                  if (loading)
                    return (
                      <center>
                        <ReactLoading
                          type="cylon"
                          height={"10%"}
                          width={"20%"}
                          color="#005D98"
                        />
                      </center>
                    );
                  if (error) return `Error!${error.message}`;
                  if (data.getResourceBrowseMapping) {
                    let {
                      showSubjectClass,
                      unitSwitch,
                      unitSwitchMessage,
                      classSN,
                      browseOrder,
                    } = data.getResourceBrowseMapping;
                    let tabList = [];
                    if (browseOrder) {
                      browseOrder.map((b) => {
                        if (b === "subject" && showSubjectClass) {
                          tabList.push(
                            <>
                              <li
                                className={
                                  pageType === "subject" ? "active" : ""
                                }>
                                <a
                                  tabIndex="0"
                                  onClick={this.changePageType.bind(
                                    this,
                                    "subject"
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.changePageType("subject", e);
                                    }
                                  }}>
                                  {t("jumper.common.tabbar.bysubject")}
                                </a>
                              </li>
                            </>
                          );
                        } else if (b === "unit" && unitSwitch) {
                          tabList.push(
                            <>
                              <li
                                className={pageType === "unit" ? "active" : ""}>
                                <a
                                  tabIndex="0"
                                  onClick={this.changePageType.bind(
                                    this,
                                    "unit"
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.changePageType("unit", e);
                                    }
                                  }}>
                                  {t(unitSwitchMessage)}
                                </a>
                              </li>
                            </>
                          );
                        } else if (b === "class") {
                          if (classSN === 0) {
                            tabList.push(
                              <>
                                <li
                                  className={
                                    pageType === "class" ? "active" : ""
                                  }>
                                  <a
                                    tabIndex="0"
                                    onClick={this.changePageType.bind(
                                      this,
                                      "class"
                                    )}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        this.changePageType("class", e);
                                      }
                                    }}>
                                    {t("jumper.common.tabbar.byclass")}
                                  </a>
                                </li>
                              </>
                            );
                          } else if (classSN > 0) {
                            tabList.push(
                              <>
                                <li
                                  className={
                                    pageType === "class" ? "active" : ""
                                  }>
                                  <a
                                    tabIndex="0"
                                    onClick={this.changePageTypeWithClassSN.bind(
                                      this,
                                      classSN
                                    )}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        this.changePageTypeWithClassSN(classSN, e);
                                      }
                                    }}>
                                    {t("jumperrwd.class.name." + classSN)}
                                  </a>
                                </li>
                              </>
                            );
                          }
                        } else if (b === "hot") {
                          tabList.push(
                            <>
                              <li
                                className={pageType === "hot" ? "active" : ""}>
                                <a
                                  tabIndex="0"
                                  onClick={this.changePageType.bind(
                                    this,
                                    "hot"
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.changePageType("hot", e);
                                    }
                                  }}>
                                  {t("jumper.common.tabbar.bypopular")}
                                </a>
                              </li>
                            </>
                          );
                        }
                      });
                    }
                    return (
                      <>
                        <div className="browse">
                          <div className="tabSet">
                            <ul className="tabs">
                              <li
                                className={pageType === "list" ? "active" : ""}>
                                <a
                                  tabIndex="0"
                                  onClick={this.changePageType.bind(
                                    this,
                                    "list"
                                  )}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.changePageType("list", e);
                                    }
                                  }}>
                                  {t("jumper.common.tabbar.browseall")}
                                </a>
                              </li>
                              {tabList}
                            </ul>
                          </div>
                          {pageType === "list" && (
                            <ResourceCharactersMapping {...this.props} />
                          )}
                          {pageType === "subject" && (
                            <ResourceSubjectMapping {...this.props} />
                          )}
                          {pageType === "unit" && (
                            <ResourceUnitMapping {...this.props} />
                          )}
                          {pageType === "class" && (
                            <ResourceClassMapping {...this.props} />
                          )}
                        </div>
                      </>
                    );
                  }
                  return "";
                }}
              </Query>
            </ApolloProvider>
          )}
          {showList && (
            <>
              <div className="function_panel">
                <div className="function_block">
                  <div className="display_grp">
                    {t("jumperrwd.common.showType")}：
                    <button
                      type="button"
                      tabIndex="0"
                      className={
                        searchForm.showType === "simple"
                          ? "list_less active"
                          : "list_less"
                      }
                      onClick={this.changeShowType.bind(this, "simple")}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.changeShowType("simple", e);
                        }
                      }}>
                      {t("jumperrwd.list.byBrief")}
                    </button>
                    <button
                      type="button"
                      tabIndex="0"
                      className={
                        searchForm.showType === "complex"
                          ? "list_more active"
                          : "list_more"
                      }
                      onClick={this.changeShowType.bind(this, "complex")}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.changeShowType("complex", e);
                        }
                      }}>
                      {t("jumperrwd.list.byDetail")}
                    </button>
                  </div>
                  <div className="result_amount">
                    <b>{t("jumperrwd.common.searchResult")}：</b>
                    <div className="total">
                      {ReactHtmlParser(
                        t("jumperrwd.list.totalAmount", {
                          total: dbResourceCount,
                        })
                      )}
                    </div>
                  </div>
                </div>
                <div className="function_block">
                  <div className="option">
                    <div
                      className="name"
                      tabIndex="0"
                      onClick={this.handleShowSort.bind(this)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.handleShowSort(e);
                        }
                      }}>
                      <a>
                        {t("jumperrwd.common.sortType")}
                        {sortFieldList.length > 0 &&
                          sortFieldList.map((sortField) => {
                            if (this.props.searchForm.sort === sortField.type) {
                              return ":" + t(sortField.message);
                            }
                            return "";
                          })}
                      </a>
                    </div>
                    {showSort && sortFieldList.length > 0 && (
                      <div className="option_list">
                        <ul>
                          {sortFieldList.map((sortField) => {
                            return (
                              <li
                              tabIndex="0"
                                onClick={this.changeSortType.bind(
                                  this,
                                  sortField.type
                                )}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    this.changeSortType(sortField.type, e);
                                  }
                                }}>
                                <a>{t(sortField.message)}</a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </div>
                  <button
                    type="button"
                    tabIndex="0"
                    className="filter_search_btn"
                    onClick={this.changeShowFilter.bind(this, true)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.changeShowFilter(true, e);
                      }
                    }}>
                    <i className="i_filter"></i>
                  </button>
                </div>
              </div>
              <div className="list_all">
                <DataList
                  query={getDBResourceList}
                  variables={{
                    searchForm: this.props.searchForm,
                  }}
                  fetchPolicy={"network-only"}
                  displayComp={DBDisplayComp}
                  pagination={"FixedPagination"}
                  getRefetch={this.getRefetch}
                  handleClick={this.handleClick}
                  onQueryCompleted={this.onQueryCompleted}
                  showNoData={true}
                />
              </div>
            </>
          )}
        </div>
        <DBResourceDetailLightBox
          ref={(c) => {
            this.detailLightBox = c;
          }}
          id={dbID}
          resourceType={resourceType}
          {...this.props}
        />
      </>
    );
  }
}

export default DBResourceListComp;
